import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fe6303c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = { class: "buy-content-box" }
const _hoisted_3 = { class: "buy-devicebox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buy-devicebox-title" }, "极飞服务", -1))
const _hoisted_5 = { class: "buy-device-list" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "buy-device-message" }
const _hoisted_8 = { class: "buy-device-title" }
const _hoisted_9 = { class: "device-name" }
const _hoisted_10 = { class: "device-price" }
const _hoisted_11 = { class: "buy-device-sn" }
const _hoisted_12 = {
  key: 0,
  class: "buy-device-notice"
}
const _hoisted_13 = { class: "buy-device-days" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "days-title" }, "购买使用天数", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "buy-type" }, [
  /*#__PURE__*/_createElementVNode("span", null, "支付方式"),
  /*#__PURE__*/_createElementVNode("span", { class: "buy-type-right" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "/images/wxpay.svg" }),
    /*#__PURE__*/_createElementVNode("span", { class: "buy-type-smalltitle" }, "微信支付")
  ])
], -1))
const _hoisted_16 = { class: "confirm-fixed" }
const _hoisted_17 = { class: "confirm-amount" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "合计金额：￥", -1))
const _hoisted_19 = { class: "amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", {
    class: "buy-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_ctx.pagePaddingTop)}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_app_header, {
        title: "购买使用时长",
        isReturnLeftEvent: true,
        onLeftClick: _ctx.handleBack
      }, null, 8, ["onLeftClick"])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reserveDeviceList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass({
                'buy-device-item': true,
                'last-item': index == _ctx.reserveDeviceList.length - 1 ? true : false,
              })
                }, [
                  _createElementVNode("img", {
                    src: item.url,
                    class: "buy-device-image"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.product_name), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.price) + "元/天", 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.product_sn), 1),
                    (item.notice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.notice), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_van_stepper, {
                        modelValue: item.buyDays,
                        "onUpdate:modelValue": ($event: any) => ((item.buyDays) = $event),
                        class: "days-number",
                        disabled: item.available_day == 0 ? true : false,
                        max: item.available_day,
                        min: 0,
                        integer: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "max"])
                    ])
                  ])
                ], 2))
              }), 256))
            ])
          ]),
          _hoisted_15
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("span", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.amountPrice.toFixed(2)), 1)
      ]),
      _createElementVNode("button", {
        class: _normalizeClass({ 'pay-btn': true, 'not-pay': _ctx.amountPrice > 0 ? false : true }),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePayAmount && _ctx.handlePayAmount(...args)))
      }, " 立即支付 ", 2)
    ])
  ], 4))
}